<script setup lang="ts">
	const rConf = useRuntimeConfig()

	const serviceareas = ref({})
	const cachedData = useNuxtData('serviceareas')
	if (cachedData.data.value) {
		serviceareas.value = cachedData.data.value
	} else {
		const { data } = await useFetch('/rest/serviceareas', {
			baseURL: rConf.public.apiBase,
			query: { is_featured: true, is_active: true },
			key: 'serviceareas'
		})
		if(data.value) {
			serviceareas.value = data.value
		}
	}
</script>

<template>
	<ul v-if="serviceareas?.items" class="space-y-6 xl:space-y-7 2xl:space-y-8">
		<li v-for="(item,idx) in serviceareas.items">
			<NuxtLink :to="{name: 'servicearea-detail', params: { servicearea_slug: item.slug }}" class="flex flex-row gap-1.5 font-light leading-snug text-[1.25rem] lg:text-[1.375] xl:text-[1.45rem] 2xl:text-[1.5rem] whitespace-nowrap text-sand-50 hover:text-primary group transition duration-300 ease-in-out" :title="item.title" no-prefetch>
				<template v-if="item.title_short">{{ item.title_short }}</template>
				<template v-else>{{ item.title }}</template>
			</NuxtLink>
		</li>
	</ul>
</template>
